var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],attrs:{"src":require("../../assets/img/loading/spin-black.svg"),"alt":"Carregando..."}})}
var staticRenderFns = []

export { render, staticRenderFns }